import { FEEL_BETTER_ABOUT_TYPE } from 'pages/questions/FeelBetterAbout/constants'

import { TOptionOf } from 'root-types'

export const FOCUS_AREA_OPTIONS = [
  {
    value: FEEL_BETTER_ABOUT_TYPE.ENERGY,
    text: 'onboarding.feelBetterAbout.energy',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.SLEEP,
    text: 'onboarding.feelBetterAbout.sleep',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.STRESS,
    text: 'onboarding.feelBetterAbout.stress',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.SKIN_AND_HAIR,
    text: 'onboarding.feelBetterAbout.skinAndHair',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.WOMENS_HEALTH,
    text: 'onboarding.feelBetterAbout.womensHealth',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.JOINT_AND_MUSCLE,
    text: 'onboarding.feelBetterAbout.jointAndMuscle',
  },
] as const satisfies readonly TOptionOf<typeof FEEL_BETTER_ABOUT_TYPE>[]
